import { applyStep } from '@/api/companyCenter'

const user = {
  state: {
    companyDetailsApplyId: 0, // 申请流程id
    companySimpleId: 0, // 公司信息id
    applyStep: 0, // 申请到第几步-跳转相关页面 0申请邮箱，1上传身份证，2企业相关信息页面，3认证成功
    email: null, // 申请的邮箱
    cardImg: null, // 身份证图片
    subCompanyList: [] //
  },
  getters: {
    companyDetailsApplyId: state => state.companyDetailsApplyId,
    companySimpleId: state => state.companySimpleId,
    applyStep: state => state.applyStep,
    email: state => state.email,
    cardImg: state => state.cardImg,
    subCompanyList: state => state.subCompanyList
  },
  mutations: {
    SET_USER_INFO: (state, info) => {
      state.companyDetailsApplyId = info.companyDetailsApplyId
      state.companySimpleId = info.companySimpleId
      state.applyStep = info.applyStep
      state.email = info.email
      state.cardImg = info.cardImg
      state.subCompanyList = info.subCompanyList
    },
    SET_APPLYSTEP: (state, step) => {
      state.applyStep = step
    },
    SET_COMPANY_ID: (state, companyDetailsData) => {
      if (companyDetailsData.companyDetailsApplyId) {
        state.companyDetailsApplyId = companyDetailsData.companyDetailsApplyId
      }
      if (companyDetailsData.companySimpleId) {
        state.companySimpleId = companyDetailsData.companySimpleId
      }
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        applyStep().then(res => {
          if (res.code === 0) {
            commit('SET_USER_INFO', res.data)
          }
          resolve(res)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    setApplyStep ({ commit }, step) {
      commit('SET_APPLYSTEP', step)
    },
    setCompanyId ({ commit }, data) {
      commit('SET_COMPANY_ID', data)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js